import { I18nString } from '@models/i18n/i18n-string';
import { UUID } from 'angular2-uuid';
import { AdminUser } from './admin-user';
import { BinaryFile } from './binary-file';
import { I18nStringMap } from './i18n/i18n-string-map';
import { User } from './user';

export type FieldType = 'TEXT' | 'DROPDOWN' | 'DATE' | 'EMAIL' | 'PHONE' | 'IMAGE' | 'IMAGE_IN_ROW1' | 'IMAGE_IN_ROW2'
                        | 'LABEL' | 'CHECKBOX' | 'USER' | 'BUTTON' | 'RADIO' | 'BUTTON' | 'BUTTON_CUSTOMIZED_PRICE'
                        | 'IMAGE_WITH_CUSTOMIZED_SIZE' | 'T_AND_C' | 'COUPON' | 'COUNTRY_DROPDOWN' | 'CHECK_AND_SHOW'
                        | 'TEXTAREA' | 'VIDEO';


export class OnepageField {
    id: string;
    fieldId: string;
    fieldName: string;
    fieldEnLabel: string;
    fieldTcLabel:string;
    fieldEnLabel2: string;
    fieldTcLabel2:string;
    fieldEnDescLabel: string;
    fieldTcDescLabel: string;
    fieldType:FieldType;
    notNull: boolean = true;
    dropDownValue: string;
    description: string;
    descriptionStyle: string;
    labelStyle: string;
    inputStyle: string;
    sequence: number;
    location: string;
    imgFile: BinaryFile;
    checkedAsDefault: boolean = false;

    fieldIconCode: string;
    showLabel: boolean = true;
    sameToTheField: string;

    displayIn: string;

    buttonProductPrice: string;
    buttonLabel: string;
    button4ProductName: string;
    button4ProductCode: string;
    insertCustomizedPriceInput: boolean = false;

	labelFontFamily: string;
	labelFontWeight: string;
	labelFontColor: string;
    labelBackgroundColor: string;
    fieldBackgroundColor: string;
    
	allowResetProductAmountInUi: boolean = false;
    showButtonAtTheBottom: boolean = false;
    maxProductAmountInOneBuy: number = 1;

    commentForCustomizedPrice: string;

    templateFieldLocationOptions: string[]=[];

    
    imageWidth: string='100%';
    imageHeight: string;
    buttonLabelTc: string;
    dropDownValueTc: string;
    validPattern: string;
    tandcApplyToWord: string;
    tandcApplyToWordTc: string;
    paddingTopHeight: string;
    isValid2Submit: boolean=true;

    defaultSystemField: boolean= false;

    _uiFlagId:string;
    constructor() {
        this._uiFlagId = UUID.UUID();
    }

    static search(term: string, item: OnepageField) {
        term = term.toLocaleLowerCase();
        return  item.fieldId.toLocaleLowerCase().indexOf(term) > -1;
    }
}

export class  OnepageFieldOption{
    id: string;   
    fieldId: string;
    fieldName: string;
    productName: string;
    productCode: string;
    refQuota: number;
}
